import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LoaderLogin.css';
import logo from '../../assets/logo.png';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    phone: '',
    password: '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      let data = JSON.stringify({
        "email": formData.email,
        "phoneNo": formData.phone,
        "newPassword": formData.password
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/admin/forgot-password`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      setIsLoading(true);
      axios.request(config)
        .then((response) => {
          // console.log(response.data);
          setIsLoading(false);
          alert('Password changed successfully.');
          navigate('/login')
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
          alert(error?.response?.data?.message);
        });

    } else {
      console.log('Form validation failed');
    }
  };

  const validateForm = () => {
    let isValid = true;
    const errors = {};

    if (!formData.email.trim()) {
      errors.email = 'Email is required';
      isValid = false;
    }

    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
      isValid = false;
    }

    if (!formData.password.trim()) {
      errors.password = 'Password is required';
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  return (
    <React.Fragment>
      <div className="flex items-center min-h-screen p-4 bg-gray-100 lg:justify-center">
        <div className="flex flex-col overflow-hidden bg-white rounded-md shadow-lg max md:flex-row md:flex-1 lg:max-w-screen-md">
          <div className="p-4 py-6 text-white bg-[#78c5ee] md:w-80 md:flex-shrink-0 md:flex md:flex-col md:items-center md:justify-evenly">
          <div className='flex justify-center'>
              <img
                className='w-20 h-auto'
                src={logo}
                alt="logo" />
            </div>
            <div className="my-3 bg-gradient-to-r from-[#f12f2f] to-[#33a7e6] bg-clip-text text-transparent text-4xl font-bold tracking-wider text-center">
              BBSR Services
            </div>
            <p className="mt-6 tracking-wide font-normal text-center text-gray-600 md:mt-0">
              BBSR Services offers tailored business solutions, including strategic consulting and advanced technology, to optimize operations and drive growth.
            </p>
            <p
              onClick={() => navigate('/')}
              className="cursor-pointer tracking-wide flex flex-col items-center justify-center mt-10 text-center">
              Get Started!
            </p>
          </div>

          <div className="p-5 bg-white md:flex-1">
            <h3 className="my-4 text-2xl font-semibold tracking-wider text-gray-700">
              Forgot Password
            </h3>

            <form onSubmit={handleSubmit} className="flex flex-col space-y-5">
              <div className="flex flex-col space-y-1">
                <label htmlFor="email" className="text-sm font-semibold tracking-wide text-gray-500">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  autoFocus
                  value={formData.email}
                  onChange={handleChange}
                  className={`px-4 py-2 transition duration-300 border rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.email && <span className="text-sm text-red-500">{errors.email}</span>}
              </div>

              <div className="flex flex-col space-y-1">
                <label htmlFor="phone" className="text-sm font-semibold tracking-wide text-gray-500">
                  Phone Number
                </label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className={`px-4 py-2 transition duration-300 border rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 ${errors.phone ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.phone && <span className="text-sm text-red-500">{errors.phone}</span>}
              </div>

              <div className="flex flex-col space-y-1">
                <label htmlFor="password" className="text-sm font-semibold tracking-wide text-gray-500">
                  Password
                </label>

                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className={`px-4 py-2 transition duration-300 border rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200 ${errors.password ? 'border-red-500' : 'border-gray-300'}`}
                />
                {errors.password && <span className="text-sm text-red-500">{errors.password}</span>}
              </div>

              <div>
                <button
                  type="submit"
                  className="flex justify-center tracking-wider w-full px-4 py-2 text-lg font-semibold text-white transition-colors duration-300 bg-blue-500 rounded-md shadow hover:bg-blue-600 focus:outline-none focus:ring-blue-200 focus:ring-4"
                >
                  {
                    isLoading
                      ?
                      <div className="load-spinner"></div>
                      :
                      'Forgot'
                  }
                </button>
              </div>

              <div
                className="text-sm text-center cursor-pointer tracking-wide Password text-blue-600 hover:underline focus:text-blue-800"
                onClick={() => navigate('/login')}
              >
                Go to Login
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgotPassword;

















// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// const ForgotPassword = () => {
//   const navigate = useNavigate();

//   return (
//     <React.Fragment>
//       <div className="flex items-center min-h-screen p-4 bg-gray-100 lg:justify-center">
//         <div className="flex flex-col overflow-hidden bg-white rounded-md shadow-lg max md:flex-row md:flex-1 lg:max-w-screen-md">
//           <div className="p-4 py-6 text-white bg-[#78c5ee] md:w-80 md:flex-shrink-0 md:flex md:flex-col md:items-center md:justify-evenly">
//             <div className="my-3 bg-gradient-to-r from-[#f12f2f] to-[#33a7e6] bg-clip-text text-transparent text-4xl font-bold tracking-wider text-center">
//               BBSR Services
//             </div>
//             <p className="mt-6 tracking-wide font-normal text-center text-gray-600 md:mt-0">
//               BBSR Services offers comprehensive business solutions, including strategic consulting and advanced technology, tailored to optimize operations and drive growth. Trust us to deliver innovation and excellence in every project.
//             </p>
//             <p className="tracking-wide flex flex-col items-center justify-center mt-10 text-center">
//               <span>Get Started!</span>
//             </p>
//           </div>

//           <div className="p-5 bg-white md:flex-1">
//             <h3 className="my-4 text-2xl font-semibold tracking-wider text-gray-700">
//               Forgot Password
//             </h3>

//             <form action="#" className="flex flex-col space-y-5">
//               <div className="flex flex-col space-y-1">
//                 <label for="email" className="text-sm font-semibold tracking-wide text-gray-500">
//                   Email
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   autofocus
//                   className="px-4 py-2 transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200"
//                 />
//               </div>

//               <div className="flex flex-col space-y-1">
//                 <label for="phone" className="text-sm font-semibold tracking-wide text-gray-500">
//                   Phone Number
//                 </label>
//                 <input
//                   type="text"
//                   id="phone"
//                   autofocus
//                   className="px-4 py-2 transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200"
//                 />
//               </div>

//               <div className="flex flex-col space-y-1">
//                 <label for="password" className="text-sm font-semibold tracking-wide text-gray-500">
//                   Password
//                 </label>

//                 <input
//                   type="password"
//                   id="password"
//                   className="px-4 py-2 transition duration-300 border border-gray-300 rounded focus:border-transparent focus:outline-none focus:ring-4 focus:ring-blue-200"
//                 />
//               </div>

//               <div>
//                 <button
//                   type="submit"
//                   className="w-full px-4 py-2 text-lg font-semibold text-white transition-colors duration-300 bg-blue-500 rounded-md shadow hover:bg-blue-600 focus:outline-none focus:ring-blue-200 focus:ring-4"
//                 >
//                   Log in
//                 </button>
//               </div>

//               <div className="text-sm text-center cursor-pointer tracking-wide Password text-blue-600 hover:underline focus:text-blue-800">
//                 Go to Login
//               </div>
//             </form>
//           </div>
//         </div>
//       </div>
//     </React.Fragment>
//   )
// }

// export default ForgotPassword
